"use client";

import React from "react";
import Link from "next/link";

interface Program {
  id: number;
  number: string;
  title: string;
  description: string;
}

interface ProgramListProps {
  programs: Program[];
}

const QuocTeProgramList: React.FC<ProgramListProps> = ({ programs }) => {
  return (
    <div className="row g-4">
      {programs.map((program) => (
        <div key={program.id} className="col-md-4">
          <Link href="/quoc-te-nganh-hoc" className="intl-program-card">
            <div className="intl-program-card__number">{program.number}</div>
            <h3 className="intl-program-card__title">{program.title}</h3>
            <p className="intl-program-card__description">{program.description}</p>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default QuocTeProgramList;
